export function validateNonUSState(value) {
    const length = value.length;
    if (length < 3) {
        return {
          value: value,
          isValid : false,
          message : "Error: Please enter your State / Province."
        }
    } else if (length > 100) {
        return {
          value: value,
          isValid : false,
          message : "Error: State / Province cannot exceed 100 characters in length."
        }
    } else {
        return {
          isValid : true,
          message : ""
        }
    }
}

export default validateNonUSState;



// WEBPACK FOOTER //
// ./src/helper/validateNonUSState.js